import { useInViewport } from 'ahooks'
import { useState, useEffect, RefObject } from 'react'

const useDelayRequest = ({ ref }: { ref: RefObject<HTMLDivElement> }) => {
  const [inViewport] = useInViewport(ref)
  const [isFirst, setIsFirst] = useState(true)

  useEffect(() => {
    if (inViewport) {
      setTimeout(() => {
        setIsFirst(false)
      })
    }
  }, [inViewport])

  return {
    isFirst,
    inViewport,
    canRequest: !(isFirst && !inViewport),
    canNoRequest: isFirst && !inViewport
  }
}

export default useDelayRequest
